<template>
  <div class="aside-menu">
    <div class="user-info-wrap">
      <div class="avatar">
        <img src="~@/assets/image/zytx.png" alt="">
      </div>
      <div class="name">{{userInfo.username}}</div>
    </div>

    <el-menu router :default-active="activeMenu">
      <el-menu-item index="/user/base">基本信息</el-menu-item>
      <el-menu-item index="/user/safety">账户安全</el-menu-item>
      <el-menu-item index="/user/management">资产管理</el-menu-item>
      <el-menu-item index="/user/approve">实名认证</el-menu-item>
      <el-menu-item index="/user/signature">签章认证</el-menu-item>
      <el-menu-item index="/user/disburse">申请贷款</el-menu-item>
      <el-menu-item index="/user/myLoaned">贷款管理</el-menu-item>
      <el-menu-item index="/user/repayment">还款管理</el-menu-item>

    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'web-aside-menu',
  computed: {
    ...mapGetters([
      'userInfo'
    ]),
    activeMenu() {
      const { meta, path } = this.$route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    }
  }
}
</script>

<style lang="scss" scoped>
$asideWidth: 220px;
.user-info-wrap {
  height: 120px;
  background-color: #fefefe;
  border-bottom: 2px solid #55c4cc;
  display: flex;
  flex-direction: column;
  align-items: center;

  .avatar {
    width: 80px;
    height: 80px;
    margin: 6px 0;
  }
  .avatar img {
    width: 100%;
    height: 100%;
    display: block;
  }
}

.aside-menu {
  width: $asideWidth;
  background-color: #fff;
  border-right: 1px solid #eee;

  .el-menu {
    border: none;
  }
  .el-menu-item {
    border-bottom: 1px dotted #eee;
  }
  .el-menu-item:hover {
    color: #3EBCC5;
    background: none;
  }
  .el-menu-item.is-active {
    background-color: #ecf8f9;
  }
}
</style>
